import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e0b9af6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upscale-edit" }
const _hoisted_2 = { class: "upscale-edit__settings" }
const _hoisted_3 = { class: "upscale-edit__settings__title" }
const _hoisted_4 = { class: "upscale-edit__settings__content" }
const _hoisted_5 = { class: "upscale-edit__settings__sizes" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upscale-edit__settings__sizes__item__icon" }, null, -1))
const _hoisted_7 = { class: "upscale-edit__settings__sizes__item__text" }
const _hoisted_8 = { class: "upscale-edit__settings__sizes__item__value" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upscale-edit__divider" }, "×", -1))
const _hoisted_10 = { class: "upscale-edit__workarea" }
const _hoisted_11 = { class: "upscale-edit__workarea__container" }
const _hoisted_12 = { class: "upscale-edit__workarea__data" }
const _hoisted_13 = { class: "upscale-edit__workarea__actions" }

import { computed, onMounted, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useEventBus } from '@vueuse/core';
import { useI18n } from 'vue-i18n';

import { useServicesStore } from '@/store/services';
import { useCommonStore } from '@/store/common';

// import { getBase64Size } from '@/helpers/getBase64Size';
import { removeBase64Prefix } from '@/helpers/removeBase64Prefix';

import AddImage from '@/components/common/AddImage/AddImage.vue';
import ImageFinetune from '@/components/common/ImageFinetune/ImageFinetune.vue';
import ResultImage from '@/components/common/ResultImage/ResultImage.vue';
import TimeCounter from '@/components/common/TimeCounter/TimeCounter.vue';

import AiButton from '@/components/UI/AiButton/AiButton.vue';
import AiCard from '@/components/UI/AiCard/AiCard.vue';
import AiClearButton from '@/components/UI/AiClearButton/AiClearButton.vue';
import AiDropLoader from '@/components/UI/AiDropLoader/AiDropLoader.vue';

const sizeLimit = 1024;


export default /*#__PURE__*/_defineComponent({
  __name: 'Upscale',
  setup(__props) {

const { t } = useI18n();

const busError = useEventBus<string>('toast-error');

const { imageForActions, imageResult, imagePrev } = storeToRefs(useServicesStore());
const { isMobile } = storeToRefs(useCommonStore());

const { generateImage } = useServicesStore();

const generationLoading = ref<boolean>(false);
const key = ref<number>(0);
const sizeIndex = ref<number>(0);
const customWidth = ref<number>(0);
const customHeight = ref<number>(0);
const imageWidth = ref<number>(0);
const imageHeight = ref<number>(0);
const isEdit = ref<boolean>(false);

// const imageSize = computed(() => getBase64Size(imageForActions.value));

const sizesList = computed(() => {
  const biggerSize = imageWidth.value > imageHeight.value ? imageWidth.value : imageHeight.value;
  const sizesDelta = sizeLimit - biggerSize;
  const sizes = [];
  if (sizesDelta > 0) {
    sizes.push(
      // {
      //   width: Math.round(imageWidth.value * ((biggerSize + sizesDelta * 0.33) / biggerSize)),
      //   height: Math.round(imageHeight.value * ((biggerSize + sizesDelta * 0.33) / biggerSize)),
      //   scale: ((biggerSize + sizesDelta * 0.33) / biggerSize).toFixed(1),
      // },
      // {
      //   width: Math.round(imageWidth.value * ((biggerSize + sizesDelta * 0.66) / biggerSize)),
      //   height: Math.round(imageHeight.value * ((biggerSize + sizesDelta * 0.66) / biggerSize)),
      //   scale: ((biggerSize + sizesDelta * 0.66) / biggerSize).toFixed(1),
      // },
      {
        width: Math.round(imageWidth.value * (sizeLimit / biggerSize)),
        height: Math.round(imageHeight.value * (sizeLimit / biggerSize)),
        scale: (sizeLimit / biggerSize).toFixed(1),
      },
    );
  } else {
    sizes.push({
      width: Math.round(imageWidth.value * (sizeLimit / biggerSize)),
      height: Math.round(imageHeight.value * (sizeLimit / biggerSize)),
      scale: (sizeLimit / biggerSize).toFixed(1),
    });
  }
  return sizes;
});

const upscaleFileHandler = (): void => {
  generationLoading.value = true;
  const newHeight = sizeIndex.value === -1 ? customHeight.value : sizesList.value[sizeIndex.value].height;
  const newWidth = sizeIndex.value === -1 ? customWidth.value : sizesList.value[sizeIndex.value].width;

  generateImage({
    action: 'upscale',
    image: removeBase64Prefix(imageForActions.value),
    params: {
      size: {
        height: newHeight,
        width: newWidth,
      },
    },
  })
    .then((res) => {
      imageResult.value = `data:image/jpeg;base64,${res.image}`;
      imagePrev.value = imageForActions.value;
    })
    .catch((e) => {
      busError.emit(e?.message || t('common.err-gen'));
    })
    .finally(() => {
      generationLoading.value = false;
    });
};
const setSize = (index: number): void => {
  sizeIndex.value = index;
};

// const updateCustomHeight = (): void => {
//   customHeight.value = Math.round(customWidth.value * (imageHeight.value / imageWidth.value));
// };

// const updateCustomWidth = (): void => {
//   customWidth.value = Math.round(customHeight.value * (imageWidth.value / imageHeight.value));
// };

const imageSizeHandler = (): void => {
  if (imageForActions.value !== '') {
    const img = new Image();
    img.onload = () => {
      imageWidth.value = img.width;
      imageHeight.value = img.height;
      customWidth.value = img.width > sizeLimit ? sizeLimit : img.width;
      customHeight.value = img.height > sizeLimit ? sizeLimit : img.height;
    };
    img.src = imageForActions.value;
    key.value += 1;
  }
};

const editHandler = (image: string): void => {
  imageForActions.value = image;
  isEdit.value = false;
};

onMounted(() => {
  imageSizeHandler();
  setSize(0);
});

watch(imageForActions, () => {
  imageSizeHandler();
  setSize(0);
});

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_img = _resolveComponent("v-img")!

  return (_unref(imageForActions) === '' && _unref(imageResult) === '')
    ? (_openBlock(), _createBlock(AddImage, { key: 0 }))
    : (_unref(imageForActions) !== '' && _unref(imageResult) === '')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["service__container upscale", { 'service__container--mobile': _unref(isMobile) }])
        }, [
          _createElementVNode("div", _hoisted_1, [
            (isEdit.value)
              ? (_openBlock(), _createBlock(ImageFinetune, {
                  key: 0,
                  class: "upscale-edit__finetune",
                  src: _unref(imageForActions),
                  onReset: _cache[0] || (_cache[0] = ($event: any) => (isEdit.value = false)),
                  onSave: editHandler,
                  actions: ['reset', 'save']
                }, null, 8, ["src"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('upscale.settings-title')), 1),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sizesList.value, (size, index) => {
                          return (_openBlock(), _createBlock(AiClearButton, {
                            key: index,
                            class: _normalizeClass(["upscale-edit__settings__sizes__item", { 'upscale-edit__settings__sizes__item--active': sizeIndex.value === index }]),
                            onClick: ($event: any) => (setSize(index))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_6,
                              _createElementVNode("div", _hoisted_7, "×" + _toDisplayString(size.scale), 1),
                              _createVNode(_component_v_spacer),
                              _createElementVNode("div", _hoisted_8, [
                                _createTextVNode(_toDisplayString(size.width) + " ", 1),
                                _hoisted_9,
                                _createTextVNode(" " + _toDisplayString(size.height) + " px ", 1)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["class", "onClick"]))
                        }), 128))
                      ]),
                      (_unref(isMobile))
                        ? (_openBlock(), _createBlock(AiButton, {
                            key: 0,
                            disabled: generationLoading.value,
                            theme: "gradient-primary",
                            onClick: upscaleFileHandler,
                            class: "upscale-edit__settings__button"
                          }, {
                            default: _withCtx(() => [
                              (!generationLoading.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('upscale.upscale')), 1)
                                  ], 64))
                                : (_openBlock(), _createBlock(TimeCounter, { key: 1 }))
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(AiCard, {
                      radius: 16,
                      class: "upscale-edit__workarea__card"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_v_img, {
                            src: _unref(imageForActions),
                            class: "upscale-edit__workarea__image"
                          }, null, 8, ["src"]),
                          (generationLoading.value)
                            ? (_openBlock(), _createBlock(AiDropLoader, { key: 0 }))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_v_spacer),
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(AiButton, {
                              theme: "dark",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (isEdit.value = true))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('common.correction')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(AiButton, {
                              theme: "dark",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => {
                  imageForActions.value = '';
                  imageResult.value = '';
                })
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('services.reset')), 1)
                              ]),
                              _: 1
                            }),
                            (!_unref(isMobile))
                              ? (_openBlock(), _createBlock(AiButton, {
                                  key: 0,
                                  disabled: generationLoading.value,
                                  theme: "gradient-primary",
                                  class: "upscale-edit__workarea__button",
                                  onClick: upscaleFileHandler
                                }, {
                                  default: _withCtx(() => [
                                    (!generationLoading.value)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(_toDisplayString(_ctx.$t('upscale.upscale')), 1)
                                        ], 64))
                                      : (_openBlock(), _createBlock(TimeCounter, { key: 1 }))
                                  ]),
                                  _: 1
                                }, 8, ["disabled"]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ], 64))
          ])
        ], 2))
      : (_unref(imageForActions) !== '' && _unref(imageResult) !== '')
        ? (_openBlock(), _createBlock(ResultImage, { key: 2 }))
        : _createCommentVNode("", true)
}
}

})